/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Segment Event Group Form" |
*
* @param {Segment_Event_Group_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_form_label = /** @type {((inputs?: Segment_Event_Group_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire de segmentation du groupe d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formular für die Segment-Ereignisgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di gruppo di eventi del segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма группы событий сегмента")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de grupo de eventos de segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分段事件组表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントイベントグループフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड घटना समूह प्रपत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de Grupo de Eventos de Segmento")
	return /** @type {LocalizedString} */ ("Segment Event Group Form")
});